import { render, staticRenderFns } from "./FMAddRevision.vue?vue&type=template&id=fac79bca&scoped=true"
import script from "./FMAddRevision.vue?vue&type=script&lang=js"
export * from "./FMAddRevision.vue?vue&type=script&lang=js"
import style0 from "./FMAddRevision.vue?vue&type=style&index=0&id=fac79bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac79bca",
  null
  
)

export default component.exports